import { Component } from '@angular/core';
import { SpinnerOverlayService } from '../../spinner-overlay/spinner-overlay.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EventsService } from '@deltager/organizers/admin/core/services/events.service';
import { EventType } from '../../models/EventType';
import {
  BookingEventService,
} from '@deltager/organizers/admin/modules/booking-event-setup/shared/booking-event.service';
import {
  UpdateAutomaticPublishAction,
} from '@deltager/organizers/admin/modules/booking-event-setup/store/booking-event-setup.actions';
import {
  BookingEventSetupState,
} from '@deltager/organizers/admin/modules/booking-event-setup/store/booking-event-setup.state';
import { Store } from '@ngrx/store';
import {
  PaymentServiceProviderService,
} from '@deltager/organizers/admin/modules/payment-service-provider/payment-service-provider.service';

@Component({
  selector: 'app-post-onboarding-landing-page',
  standalone: true,
  imports: [],
  templateUrl: './post-onboarding-landing-page.component.html',
  styleUrl: './post-onboarding-landing-page.component.scss',
})
export class PostOnboardingLandingPageComponent {
  constructor(private spinnerService: SpinnerOverlayService, route: ActivatedRoute,
              private eventService: EventsService, private bookingEventService: BookingEventService,
              private router: Router, private store: Store<{ booking: BookingEventSetupState }>,
              private paymentServiceProviderService: PaymentServiceProviderService,
  ) {
    this.spinnerService.show();

    route.queryParams.subscribe(async p => {
      const eventId = p['eventId'];
      const eventType = p['eventType'];

      if (!eventId || !eventType) {
        return;
      }

      const status = await this.paymentServiceProviderService.getProviderStatus(eventId, eventType);

      if (status.chargesEnabled) {
        this.publish(eventId, eventType);
      } else {
        this.spinnerService.hide();

        if (eventType == EventType.Regular) {
          this.router.navigate(['events', 'edit', eventId.toString()]);
        } else if (eventType == EventType.BookingV2) {
          this.router.navigate(['booking-events', eventId.toString()]);
        }
      }
    });
  }

  publish(eventId: number, eventType: EventType): void {

    if (eventType == EventType.Regular) {

      this.eventService.publishEvent(eventId).subscribe(() => {
        this.spinnerService.hide();

        this.router.navigate(['events', 'edit', eventId.toString()], {
          queryParams: {
            postOnboard: true,
          },
        });
      });

    } else if (eventType == EventType.BookingV2) {

      const automaticPublishAction = new UpdateAutomaticPublishAction(true);
      this.store.dispatch(automaticPublishAction);

      this.bookingEventService.publish(eventId).subscribe(() => {

        this.spinnerService.hide();

        this.router.navigate(['booking-events', eventId.toString()], {
          queryParams: {
            receipt: true,
          },
        });
      });

    } else {
      throw new Error();
    }
  }
}
